export default __webpack_public_path__ + "static/media/BestPriceDiscovery.6485d08b.png";